export default {
  data() {
    return {
      searchSchema: [
        {
          label: '企业名称',
          type: 'input',
          itemName: 'name',
          allowClear: true,
        },
        {
          label: '企业ID',
          type: 'input',
          itemName: 'code',
          allowClear: true,
        },
        {
          label: '风险标签',
          itemName: 'labelName',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '信用主管',
          itemName: 'creditManager',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '业务类型',
          itemName: 'businessId',
          type: 'select',
          selectList: [],
          handleChange: this.handleModelChange,
          allowClear: true,
        },
        {
          label: '业务模式',
          itemName: 'modelId',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
      ],
      tableData: [],
      searchForm: {
        name: '',
        code: '',
        creditManager: '',
        businessId: '',
        labelName: '',
        modelId: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 70,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '企业名称',
          width: 250,
          dataIndex: 'name',
        },
        {
          title: '企业ID',
          width: 240,
          dataIndex: 'code',
        },
        {
          title: '风险标签',
          width: 240,
          dataIndex: 'tagLabel',
        },
        {
          title: '业务类型',
          width: 180,
          dataIndex: 'business',
        },
        {
          title: '业务模式',
          width: 180,
          dataIndex: 'model',
        },
        {
          title: '信用主管',
          width: 180,
          dataIndex: 'creditManager',
        },
        {
          title: '标签标记时间',
          width: 180,
          dataIndex: 'createTime',
        },
        {
          title: '标签标记人',
          width: 180,
          dataIndex: 'tagBy',
        },
      ],
      tableHistoryColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageHistoryData.current - 1) *
                this.pageHistoryData.pageSize +
              index +
              1
            )
          },
        },
        {
          title: '企业名称',
          width: 240,
          dataIndex: 'name',
        },
        {
          title: '企业ID',
          width: 240,
          dataIndex: 'code',
        },
        {
          title: '修改前-风险标签',
          width: 240,
          dataIndex: 'tagLabel',
        },
        {
          title: '最新-风险标签',
          width: 240,
          dataIndex: 'newLabel',
        },
        {
          title: '业务类型',
          width: 180,
          dataIndex: 'business',
        },
        {
          title: '业务模式',
          width: 180,
          dataIndex: 'model',
        },
        {
          title: '信用主管',
          width: 180,
          dataIndex: 'creditManager',
        },
        {
          title: '标签标记时间',
          width: 180,
          dataIndex: 'createTime',
        },
        {
          title: '标签标记人',
          width: 180,
          dataIndex: 'tagBy',
        },
        {
          title: '标签修改时间',
          width: 180,
          dataIndex: 'updateTime',
        },
        {
          title: '标记修改人',
          width: 180,
          dataIndex: 'modifyBy',
        },
      ],
      pageHistoryData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
    }
  },
  methods: {
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
    handleHistoryClickPage({ current, pageSize }) {
      this.pageHistoryData = { ...this.pageHistoryData, current, pageSize }
      this._getHistoryTableData()
    },
  },
}
